<style lang="scss">
    .close-tip {
        margin-top: 19px;
        padding: 10px 0;
        box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.20);
        text-align: center;
        @media (min-width: 992px) {
            padding: 100px 50px;
        }
        @media (min-width: 1200px) {
            padding: 100px 70px;
        }
        .msg {
            margin-top: 40px;
            color: #333333;
        }
    }

</style>
<template>
    <div>
        <div class="close-tip">
            <div class="ico">
                <img src="../../assets/images/closeTip.png"/>
            </div>
            <div class="msg">
                <p >{{this.$t("examRegisteation.closeTip")}}</p>
            </div>
        </div>
        <ata-footer></ata-footer>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
        created: function () {
            this.$store.commit('setHeaderState', '3');
        }
    }
</script>

